import PageIcon from './page.svg';

export default {
  'pages/page-icon': PageIcon,
};
